import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function AylikMakineSureChart({ data }) {
  const chartData = useMemo(() => {
    if (!data?.length) return null;

    const labels = data.map((d) => d.ay);
    const makine1 = data.map((d) => d.ayToplam?.find((m) => m.makinaAdi === "1")?.toplamSure || 0);
    const makine2 = data.map((d) => d.ayToplam?.find((m) => m.makinaAdi === "2")?.toplamSure || 0);
    const makine3 = data.map((d) => d.ayToplam?.find((m) => m.makinaAdi === "3")?.toplamSure || 0);
    const makine4 = data.map((d) => d.ayToplam?.find((m) => m.makinaAdi === "4")?.toplamSure || 0);

    return {
      labels,
      datasets: [
        {
          label: "Makina 1",
          data: makine1,
          backgroundColor: "#0d6efd",
        },
        {
          label: "Makina 2",
          data: makine2,
          backgroundColor: "#dc3545",
        },
        {
          label: "Makina 3",
          data: makine3,
          backgroundColor: "#198754",
        },
        {
          label: "Makina 4",
          data: makine4,
          backgroundColor: "#ffc107",
        },
      ],
    };
  }, [data]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: { font: { size: 14 } },
      },
      title: {
        display: true,
        text: "Aylık Makine Çalışma Süreleri (dk)",
        font: { size: 18, weight: "bold" },
      },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.dataset.label}: ${ctx.parsed.y.toLocaleString()} dk`,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Aylar",
          font: { size: 14 },
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Toplam Süre (dk)",
          font: { size: 14 },
        },
        ticks: {
          callback: (value) => value.toLocaleString(),
        },
      },
    },
  };

  return (
    <div className="p-4 bg-white rounded shadow-sm mt-4">
      {chartData ? (
        <Bar data={chartData} options={options} />
      ) : (
        <p className="text-muted text-center">Veri bulunamadı</p>
      )}
    </div>
  );
}

export default AylikMakineSureChart;
